import React from 'react';
import { connect } from 'react-redux';
import { Button, IconButton } from 'react-toolbox/lib/button';
import { get } from '~/actions/containers';
import Tag from '~/components/Tag';
import Title from '~/components/Title';
import styleDialog from '~/style/dialog.scss';
import style from './style.scss';

class Dialog extends React.Component {
  static contextTypes = {
    dialogClose: React.PropTypes.func.isRequired,
    dialogPush: React.PropTypes.func.isRequired,
    apiClient: React.PropTypes.object.isRequired
  };

  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      stockPage: 1
    };
  }

  componentDidMount() {
    return get(this.props.dispatch, this.context.apiClient, this.props.data.id)
      .then(() => this.setState({ loading: false }))
      .catch(() => this.setState({ loading: false }));
  }

  renderDialog() {
    const { bundle } = this.props;
    const articleIds = Object.keys(bundle.articleIds);
    const rawMaterialIds = Object.keys(bundle.rawMaterialIds);
    return (
      <div>
        <Button
          style={{ float: 'right' }}
          label="Edit details"
          className={style.buttonEdit}
          onClick={() =>
            this.context.dialogPush('bundleEdit', { id: bundle.id })
          }
        />
        <Title style={{ marginBottom: '10px' }}>Information</Title>
        <div>Bundle #{bundle.sku}</div>
        <div>UPC: {bundle.upc || 'Not set'}</div>
        <Title style={{ margin: '20px 0 10px 0' }}>Articles</Title>
        {articleIds.map(id => (
          <div key={`bundle_article_${id}`} className={style.articleRow}>
            <div className={style.title}>
              <Tag id={id} type="article" />
            </div>
            <div className={style.count}>{bundle.articleIds[id]}</div>
          </div>
        ))}
        {articleIds.length === 0 ? 'There are no articles in this bundle.' : null}
        <Title style={{ margin: '20px 0 10px 0' }}>Raw materials</Title>
        {rawMaterialIds.map(id => (
          <div key={`bundle_rawMaterial_${id}`} className={style.articleRow}>
            <div className={style.title}>
              <Tag id={id} type="rawMaterial" />
            </div>
            <div className={style.count}>{bundle.rawMaterialIds[id]}</div>
          </div>
        ))}
        {rawMaterialIds.length === 0 ? 'There are no raw materials in this bundle.' : null}
        {bundle.removed && <div className={style.removed}>REMOVED</div>}
      </div>
    );
  }

  render() {
    return (
      <div
        className={[
          styleDialog.background,
          styleDialog[this.props.transition]
        ].join(' ')}
        onClick={() => this.context.dialogClose(this.props.dialogId)}
      >
        <div
          className={styleDialog.container}
          onClick={e => e.stopPropagation()}
        >
          <IconButton
            className={styleDialog.closeButton}
            icon="close"
            onClick={() => this.context.dialogClose(this.props.dialogId)}
          />
          <div className={styleDialog.content}>
            {this.state.loading && 'Loading'}
            {!this.state.loading && !this.props.bundle && '404'}
            {!this.state.loading && this.props.bundle && this.renderDialog()}
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state, props) => {
  const bundle =
    state.getIn(['bundles', 'items', props.data.id]) &&
    state.getIn(['bundles', 'items', props.data.id]).toJS();
  return { bundle };
};

export default connect(mapStateToProps)(Dialog);



// WEBPACK FOOTER //
// ./app/dialogs/Bundle/index.js